// The sign-in and reset-password screens
const en = {
  artTitle: 'Your lineup, your map, your app.',
  artSubtitle: 'Everything the festival app shows is edited here.',
  festivalId: 'Festival ID',
  findingFestival: 'Finding your festival…',
  email: 'Email',
  password: 'Password',

  signInTitle: 'Sign in',
  signInSubtitle: "Manage your festival's app.",
  forgotPassword: 'Forgot password?',
  signIn: 'Sign in',
  signingIn: 'Signing in...',
  signInError: 'An error occurred during login',

  resetTitle: 'Reset password',
  resetSubtitle: "We'll email you a code to choose a new password.",
  sendCode: 'Send a code',
  sending: 'Sending...',
  sendCodeError: 'Failed to generate reset code',
  newPasswordTitle: 'Enter New Password',
  validationCode: 'Validation Code',
  newPassword: 'New Password',
  repeatPassword: 'Repeat Password',
  updatePassword: 'Update Password',
  updatePasswordError: 'Failed to update password',
  passwordsDontMatch: 'Passwords do not match',
};

const fr: typeof en = {
  artTitle: 'Votre lineup, votre plan, votre app.',
  artSubtitle: "Tout ce que l'app du festival affiche se modifie ici.",
  festivalId: 'Identifiant du festival',
  findingFestival: 'Recherche de votre festival…',
  email: 'E-mail',
  password: 'Mot de passe',

  signInTitle: 'Connexion',
  signInSubtitle: "Gérez l'app de votre festival.",
  forgotPassword: 'Mot de passe oublié\u00a0?',
  signIn: 'Se connecter',
  signingIn: 'Connexion...',
  signInError: 'Une erreur est survenue lors de la connexion',

  resetTitle: 'Réinitialiser le mot de passe',
  resetSubtitle: 'Nous vous envoyons un code par e-mail pour choisir un nouveau mot de passe.',
  sendCode: 'Envoyer un code',
  sending: 'Envoi...',
  sendCodeError: "Impossible d'envoyer le code",
  newPasswordTitle: 'Choisissez un nouveau mot de passe',
  validationCode: 'Code de validation',
  newPassword: 'Nouveau mot de passe',
  repeatPassword: 'Répétez le mot de passe',
  updatePassword: 'Changer le mot de passe',
  updatePasswordError: 'Impossible de changer le mot de passe',
  passwordsDontMatch: 'Les mots de passe ne correspondent pas',
};

const messages = { en, fr };
export default messages;
